import React from 'react'
import { Box, Skeleton } from "@mui/material"


const ResponsiveRectangle = (props) =>{
    const {height} = props
    return (
        <Box p={2}>
            <Skeleton variant="rectangular" animation="wave" sx={{paddingTop: height+"%"}} height={0} />
        </Box>
    )
}
export default ResponsiveRectangle